module Elma.Bindings {
    export interface IpreventDefault {        
    }
    export class ClickPreventDefault {
        public init(element: any, valueAccessor: () => IpreventDefault, allBindingsAccessor?: KnockoutAllBindingsAccessor, viewModel?: any, bindingContext?: KnockoutBindingContext) {
            if (!bindingContext)
                return;

            ko.utils.registerEventHandler(element, "click", function (e) {
                e.preventDefault();
            });
        }
    }
    ko.bindingHandlers['clickPreventDefault'] = new ClickPreventDefault();
} 
